import { inject } from '@angular/core';
import { type CanActivateFn, Router } from '@angular/router';
import { ACTIVE_SHOP_DATA } from '@informally/frontend/active-shop';
import { TranslateService } from '@ngx-translate/core';

export const publicLanguageGuard: CanActivateFn = async (route) => {
  const router = inject(Router);
  const shopData = inject(ACTIVE_SHOP_DATA);
  const translateService = inject(TranslateService);

  const { language } = route.params;
  const { supportedLangs, defaultLang } = await shopData();

  if (!supportedLangs.includes(language)) {
    return router.createUrlTree([defaultLang]);
  }

  translateService.setDefaultLang(defaultLang);
  translateService.use(language);

  return true;
};
